import { render, staticRenderFns } from "./MappingRenewalEdit.vue?vue&type=template&id=0fe137e0&scoped=true&"
import script from "./MappingRenewalEdit.vue?vue&type=script&lang=js&"
export * from "./MappingRenewalEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe137e0",
  null
  
)

export default component.exports